import { intl } from '../locales/localesConfig';
import Constants from '../definitions/constants';
import LocaleTooling from '../tooling/localeTooling';

const TableDescriptors = {
  userList: {
    columns: [
      { key: "email", label: intl.formatMessage({ id: "userAdmin.fields.email" }), 
        sortable: true, size: 4 },
      { key: "name", label: intl.formatMessage({ id: "userAdmin.fields.name" }), 
        sortable: true, sortField: "last_names", size: 4 },
      { key: "role", label: intl.formatMessage({ id: "userAdmin.fields.role" }), translateList:  "user.roles", 
        sortable: true, align: Constants.style.alignTypes.CENTER, size: 2 },
      { key: "last_login", label: intl.formatMessage({ id: "userAdmin.fields.last_login" }), 
        sortable: true, sortField: "last_sign_in_at", dataType: Constants.crudGenerator.dataTypes.DATETIME, 
        align: Constants.style.alignTypes.CENTER, size: 3 },
      { key: "is_active", label: intl.formatMessage({ id: "userAdmin.fields.is_active" }), 
        sortable: true, sortField: "confirmed_at", dataType: Constants.crudGenerator.dataTypes.BOOLEAN, 
        align: Constants.style.alignTypes.CENTER, size: 3 }
    ],
    generalTextSearchFields: ["email", "last_names", "first_names"],
    entityNamePlural: intl.formatMessage({ id: "userAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "userAdmin.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "userAdmin.genderVocal" })
  },
  calculationUnitList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "calculationUnitAdmin.fields.name" }), 
        sortable: true, sortField: "last_names", size: 3 },
      { key: "code", label: intl.formatMessage({ id: "calculationUnitAdmin.fields.code" }), 
        sortable: true, size: 2 },
      { key: "email", label: intl.formatMessage({ id: "calculationUnitAdmin.fields.email" }), 
        sortable: true, size: 2 },
      { key: "period_created_at", label: intl.formatMessage({ id: "calculationUnitAdmin.fields.period_created_at" }), dataType: Constants.crudGenerator.dataTypes.DATETIME,
        sortable: false, size: 2 }
    ],
    generalTextSearchFields: ["code", "last_names", "first_names"],    
    entityNamePlural: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "calculationUnitAdmin.entityNamePlural" })),  
    entityNameSingular: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "calculationUnitAdmin.entityNameSingular" })),
    genderVocal: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "calculationUnitAdmin.genderVocal" })),
    auditColumnInfo: "update_info",
    auditColumnNotificationId: "update_job_key",
    auditColumnSize: 4,
  },
  groupList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "groupAdmin.fields.name" }), 
        sortable: true, size: 1 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "groupAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "groupAdmin.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "groupAdmin.genderVocal" })
  },
  assignGroupGroupList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "groupAdmin.fields.name" }), size: 1 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "groupAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "groupAdmin.entityNameSingular" })
  },
  assignGroupCalculationUnitList: {
    columns: [
      { key: "name_code", sortField: "last_names", label: intl.formatMessage({ id: "calculationUnitAdmin.fields.name" }), size: 4 },
      { key: "groups_string", label: intl.formatMessage({ id: "assignGroupAdmin.groupsTitle" }), align: Constants.style.alignTypes.LEFT, size: 3 }
    ],
    generalTextSearchFields: ["code", "last_names", "first_names"],
    entityNamePlural: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "calculationUnitAdmin.entityNamePlural"})),      
    entityNameSingular: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "calculationUnitAdmin.entityNamePlural"}))
  },
  assignPolynomialGroupGroupList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "groupAdmin.fields.name" }), size: 4 },
      { key: "polynomials_string", label: intl.formatMessage({ id: "assignPolynomialGroupAdmin.polynomialsTitle" }), 
       align: Constants.style.alignTypes.LEFT, size: 3 }
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "groupAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "groupAdmin.entityNameSingular" })
  },
  assignPolynomialGroupPolynomialList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "polynomialAdmin.fields.name" }), size: 4 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "polynomialAdmin.entityNamePluralModel" }),      
    entityNameSingular: intl.formatMessage({ id: "polynomialAdmin.entityNameSingularModel" })
  },
  assignPolynomialCalculationUnitCalculationUnitList: {
    columns: [
      { key: "name_code", sortField: "last_names", label: intl.formatMessage({ id: "calculationUnitAdmin.fields.name" }), size: 4 },
      { key: "polynomials_string", label: intl.formatMessage({ id: "assignPolynomialCalculationUnitAdmin.polynomialsTitle" }), 
       align: Constants.style.alignTypes.LEFT, size: 3 }
    ],
    generalTextSearchFields: ["code", "last_names", "first_names"],
    entityNamePlural: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "calculationUnitAdmin.entityNamePlural"})),      
    entityNameSingular: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "calculationUnitAdmin.entityNameSingular"})),
  },
  assignPolynomialCalculationUnitPolynomialList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "polynomialAdmin.fields.name" }), size: 4 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "polynomialAdmin.entityNamePluralModel" }),      
    entityNameSingular: intl.formatMessage({ id: "polynomialAdmin.entityNameSingularModel" })
  },
  dimensionList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "dimensionAdmin.fields.name" }), 
        sortable: true, size: 1 },
      { key: "data_type", label: intl.formatMessage({ id: "dimensionAdmin.fields.data_type" }),
        translateList:  "dimensionAdmin.fields.selectValues.data_type", 
        sortable: true, align: Constants.style.alignTypes.CENTER, size: 1 },
      { key: "updated_at", label: intl.formatMessage({ id: "dimensionAdmin.fields.updated_at" }), 
        sortable: true, dataType: Constants.crudGenerator.dataTypes.DATETIME, 
        align: Constants.style.alignTypes.CENTER, size: 1 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "dimensionAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "dimensionAdmin.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "dimensionAdmin.genderVocal" })
  },
  metricList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "metricAdmin.fields.name" }), 
        sortable: true, size: 1 },
      { key: "data_type", label: intl.formatMessage({ id: "metricAdmin.fields.data_type" }),
        translateList:  "metricAdmin.fields.selectValues.data_type", 
        sortable: true, align: Constants.style.alignTypes.CENTER, size: 1 },
      { key: "metric_type", label: intl.formatMessage({ id: "metricAdmin.fields.metric_type" }),
        translateList:  "metricAdmin.fields.selectValues.metric_type", 
        sortable: true, align: Constants.style.alignTypes.CENTER, size: 1 },
      { key: "updated_at", label: intl.formatMessage({ id: "metricAdmin.fields.updated_at" }), 
        sortable: true, dataType: Constants.crudGenerator.dataTypes.DATETIME, 
        align: Constants.style.alignTypes.CENTER, size: 1 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "metricAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "metricAdmin.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "metricAdmin.genderVocal" })
  },
  virtualMetricList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "metricAdmin.fields.name" }), 
        sortable: true, size: 1 },
      { key: "data_type", label: intl.formatMessage({ id: "metricAdmin.fields.data_type" }),
        translateList:  "metricAdmin.fields.selectValues.data_type", 
        sortable: true, align: Constants.style.alignTypes.CENTER, size: 1 },
      { key: "updated_at", label: intl.formatMessage({ id: "metricAdmin.fields.updated_at" }), 
        sortable: true, dataType: Constants.crudGenerator.dataTypes.DATETIME, 
        align: Constants.style.alignTypes.CENTER, size: 1 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "virtualMetricAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "virtualMetricAdmin.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "virtualMetricAdmin.genderVocal" })
  },
  metricsGroupList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "metricsGroupAdmin.fields.name" }), 
        sortable: true, size: 2 },
      { key: "metrics_names", label: intl.formatMessage({ id: "metricsGroupAdmin.fields.metrics_names" }), 
        sortable: true, size: 5 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "metricsGroupAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "metricsGroupAdmin.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "metricsGroupAdmin.genderVocal" })
  },
  polynomialList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "polynomialAdmin.fields.name" }), 
        sortable: true, size: 2 },
      { key: "model", label: intl.formatMessage({ id: "polynomialAdmin.fields.model" }), 
        sortable: true, dataType: Constants.crudGenerator.dataTypes.BOOLEAN, 
        align: Constants.style.alignTypes.CENTER, size: 1 },
      { key: "sub_model", label: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "polynomialAdmin.fields.sub_model_short" })), 
        sortable: true, dataType: Constants.crudGenerator.dataTypes.BOOLEAN, 
        align: Constants.style.alignTypes.CENTER, size: 1 },
      { key: "order", label: intl.formatMessage({ id: "polynomialAdmin.fields.reportDetailsLabels.order" }), 
      sortable: true, dataType: Constants.crudGenerator.dataTypes.NUMBER, 
      align: Constants.style.alignTypes.CENTER, size: 1 },
      { key: "updated_at", label: intl.formatMessage({ id: "polynomialAdmin.fields.updated_at" }), 
        sortable: true, dataType: Constants.crudGenerator.dataTypes.DATETIME, 
        align: Constants.style.alignTypes.CENTER, size: 1 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "polynomialAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "polynomialAdmin.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "polynomialAdmin.genderVocal" })
  },
  notificationsList: {
    columns: [
      { key: "code", label: intl.formatMessage({ id: "notifications.fields.code" }), 
        translateList:  "notifications.codes", size: 2 },
      { key: "detail", label: intl.formatMessage({ id: "notifications.fields.detail" }), size: 4 },
      { key: "period_name", label: intl.formatMessage({ id: "notifications.fields.period_name" }), size: 2 },
      { key: "created_at", label: intl.formatMessage({ id: "notifications.fields.created_at" }), 
        dataType: Constants.crudGenerator.dataTypes.DATETIME, align: Constants.style.alignTypes.CENTER, size: 3 },
      { key: "duration", label: intl.formatMessage({ id: "notifications.fields.duration" }), size: 2, align: Constants.style.alignTypes.CENTER },
      { key: "process_state", align: Constants.style.alignTypes.CENTER, 
       translateList:  "notifications.process_states", label: intl.formatMessage({ id: "notifications.fields.process_state" }), size: 2 },
      { key: "process_information", label: intl.formatMessage({ id: "notifications.fields.process_information" }), size: 4 }
    ],
    entityNamePlural: intl.formatMessage({ id: "notifications.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "notifications.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "notifications.genderVocal" })
  },
  calculationsList: {
    columns: [
      { key: "created_at", label: intl.formatMessage({ id: "calculations.fields.created_at" }), 
        dataType: Constants.crudGenerator.dataTypes.DATETIME, size: 2 },
      { key: "detail", label: intl.formatMessage({ id: "calculations.fields.detail" }), size: 3 },
      { key: "calculation_units_info", label: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "calculations.fields.calculation_units_count" })), 
       size: 2, align: Constants.style.alignTypes.CENTER },
      { key: "models_info", label: intl.formatMessage({ id: "calculations.fields.models_info" }), 
       size: 2, align: Constants.style.alignTypes.CENTER }      
    ],
    entityNamePlural: intl.formatMessage({ id: "calculations.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "calculations.entityNameSingular" }),  
    entityNameSingularWithArticle: intl.formatMessage({ id: "calculations.entityNameSingularWithArticle" }),
    genderVocal: intl.formatMessage({ id: "calculations.genderVocal" })
  },
  calculationsReprocessList: {
    columns: [
      { key: "created_at", label: intl.formatMessage({ id: "calculations.fields.created_at" }), 
        dataType: Constants.crudGenerator.dataTypes.DATETIME, size: 2 },
      { key: "detail", label: intl.formatMessage({ id: "calculations.fields.detail" }), size: 3 },
      { key: "calculation_units_info", label: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "calculations.fields.calculation_units_count" })), 
       size: 2, align: Constants.style.alignTypes.CENTER },
      { key: "models_info", label: intl.formatMessage({ id: "calculations.fields.models_info" }), 
       size: 2, align: Constants.style.alignTypes.CENTER },
      { key: "reprocess_label", label: intl.formatMessage({ id: "calculations.fields.reprocess_label" }), size: 2, align: Constants.style.alignTypes.CENTER }
    ],
    entityNamePlural: intl.formatMessage({ id: "calculations.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "calculations.entityNameSingular" }),  
    entityNameSingularWithArticle: intl.formatMessage({ id: "calculations.entityNameSingularWithArticle" }),
    genderVocal: intl.formatMessage({ id: "calculations.genderVocal" })
  },
  periodList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "periodAdmin.fields.name" }), size: 1 },
      { key: "state", align: Constants.style.alignTypes.CENTER, 
       translateList:  "periodAdmin.period_states", label: intl.formatMessage({ id: "periodAdmin.fields.state" }), size: 1 },
      { key: "start_date_iso", label: intl.formatMessage({ id: "periodAdmin.fields.start_date" }), 
        dataType: Constants.crudGenerator.dataTypes.DATE, size: 1 },
      { key: "end_date_iso", label: intl.formatMessage({ id: "periodAdmin.fields.end_date" }), 
        dataType: Constants.crudGenerator.dataTypes.DATE, size: 1 },
      { key: "query_date_iso", label: intl.formatMessage({ id: "periodAdmin.fields.query_date" }), 
        dataType: Constants.crudGenerator.dataTypes.DATE, size: 1 },
      { key: "created_at", label: intl.formatMessage({ id: "periodAdmin.fields.created_at" }), 
        dataType: Constants.crudGenerator.dataTypes.DATETIME, size: 1 },
      { key: "closed_at", label: intl.formatMessage({ id: "periodAdmin.fields.closed_at" }), 
        dataType: Constants.crudGenerator.dataTypes.DATETIME, size: 1 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "periodAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "periodAdmin.entityNameSingular" }),  
    entityNameSingularWithArticle: intl.formatMessage({ id: "periodAdmin.entityNameSingularWithArticle" }),
    genderVocal: intl.formatMessage({ id: "periodAdmin.genderVocal" })
  },
  calculationsHistoryList: {
    columns: [
      { key: "period", label: intl.formatMessage({ id: "calculationsHistory.fields.period" }), size: 1 },
      { key: "calculation_unit", label: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "calculationsHistory.fields.calculation_unit" })), size: 1 },
      { key: "polynomial", label: intl.formatMessage({ id: "calculationsHistory.fields.polynomial" }), size: 1 },
      { key: "value", label: intl.formatMessage({ id: "calculationsHistory.fields.value" }), size: 1, 
        dataType: Constants.crudGenerator.dataTypes.NUMBER, align: Constants.style.alignTypes.CENTER },
      { key: "detail", label: intl.formatMessage({ id: "calculationsHistory.fields.detail" }), size: 1, 
        dataType: Constants.crudGenerator.dataTypes.NUMBER, align: Constants.style.alignTypes.CENTER },
      { key: "goal", label: intl.formatMessage({ id: "calculationsHistory.fields.goal" }), size: 1, 
        dataType: Constants.crudGenerator.dataTypes.NUMBER, align: Constants.style.alignTypes.CENTER },
    ],
    entityNamePlural: intl.formatMessage({ id: "calculationsHistory.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "calculationsHistory.entityNameSingular" }),  
    entityNameSingularWithArticle: intl.formatMessage({ id: "calculationsHistory.entityNameSingularWithArticle" }),
    genderVocal: intl.formatMessage({ id: "calculationsHistory.genderVocal" })
  },
  calculationInstancesDeleteList: {
    columns: [      
      { key: "active", label: intl.formatMessage({ id: "calculationsHistory.fields.active" }), 
        dataType: Constants.crudGenerator.dataTypes.BOOLEAN, 
        align: Constants.style.alignTypes.CENTER, size: 1 },
      { key: "is_reprocess", label: intl.formatMessage({ id: "calculationsHistory.fields.is_reprocess" }), 
        dataType: Constants.crudGenerator.dataTypes.BOOLEAN, 
        align: Constants.style.alignTypes.CENTER, size: 1 },
      { key: "created_at", label: intl.formatMessage({ id: "calculationsHistory.fields.created_at" }), 
        dataType: Constants.crudGenerator.dataTypes.DATETIME, size: 1 },
      { key: "value", label: intl.formatMessage({ id: "calculationsHistory.fields.value" }), size: 1, 
        dataType: Constants.crudGenerator.dataTypes.NUMBER, align: Constants.style.alignTypes.CENTER },
      { key: "detail", label: intl.formatMessage({ id: "calculationsHistory.fields.detail" }), size: 1, 
        dataType: Constants.crudGenerator.dataTypes.NUMBER, align: Constants.style.alignTypes.CENTER },
      { key: "goal", label: intl.formatMessage({ id: "calculationsHistory.fields.goal" }), size: 1, 
        dataType: Constants.crudGenerator.dataTypes.NUMBER, align: Constants.style.alignTypes.CENTER },
    ],
    entityNamePlural: intl.formatMessage({ id: "calculationsHistory.calculationInstancesDetail.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "calculationsHistory.calculationInstancesDetail.entityNameSingular" }),  
    entityNameSingularWithArticle: intl.formatMessage({ id: "calculationsHistory.calculationInstancesDetail.entityNameSingularWithArticle" }),
    genderVocal: intl.formatMessage({ id: "calculationsHistory.calculationInstancesDetail.genderVocal" })
  },
  preCalculationsHistoryList: {
    columns: [
      { key: "period", label: intl.formatMessage({ id: "preCalculationsHistory.fields.period" }), size: 1 },
      { key: "dimension_name", label: intl.formatMessage({ id: "preCalculationsHistory.fields.dimension_name" }), size: 1 },
      { key: "dimension_instance", label: intl.formatMessage({ id: "preCalculationsHistory.fields.dimension_instance" }), size: 1 },
      { key: "polynomial", label: intl.formatMessage({ id: "preCalculationsHistory.fields.pre_polynomial" }), size: 1 },
      { key: "value", label: intl.formatMessage({ id: "preCalculationsHistory.fields.value" }), size: 1, 
        dataType: Constants.crudGenerator.dataTypes.NUMBER, align: Constants.style.alignTypes.CENTER },
      { key: "detail", label: intl.formatMessage({ id: "preCalculationsHistory.fields.detail" }), size: 1, 
        dataType: Constants.crudGenerator.dataTypes.NUMBER, align: Constants.style.alignTypes.CENTER },
      { key: "goal", label: intl.formatMessage({ id: "preCalculationsHistory.fields.goal" }), size: 1, 
        dataType: Constants.crudGenerator.dataTypes.NUMBER, align: Constants.style.alignTypes.CENTER },
    ],
    entityNamePlural: intl.formatMessage({ id: "preCalculationsHistory.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "preCalculationsHistory.entityNameSingular" }),  
    entityNameSingularWithArticle: intl.formatMessage({ id: "preCalculationsHistory.entityNameSingularWithArticle" }),
    genderVocal: intl.formatMessage({ id: "preCalculationsHistory.genderVocal" })
  },
  processingMetricsImportNotifications: {
    columns: [
      { key: "detail", label: intl.formatMessage({ id: "notifications.fields.detail" }), size: 3 },
      { key: "period_name", label: intl.formatMessage({ id: "notifications.fields.period_name" }), size: 2 },
      { key: "created_at", label: intl.formatMessage({ id: "notifications.fields.created_at" }), 
        dataType: Constants.crudGenerator.dataTypes.DATETIME, align: Constants.style.alignTypes.CENTER, size: 2 },
      { key: "duration", label: intl.formatMessage({ id: "notifications.fields.duration" }), size: 2, align: Constants.style.alignTypes.CENTER },
      { key: "process_state", align: Constants.style.alignTypes.CENTER, 
       translateList:  "notifications.process_states", label: intl.formatMessage({ id: "notifications.fields.process_state" }), size: 2 },
      { key: "process_information", align: Constants.style.alignTypes.CENTER, 
       label: intl.formatMessage({ id: "notifications.fields.process_information" }), size: 2 }
    ],
    entityNamePlural: intl.formatMessage({ id: "metricDataAdmin.processingMetricsDataInfo.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "metricDataAdmin.processingMetricsDataInfo.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "metricDataAdmin.processingMetricsDataInfo.genderVocal" })
  },
  importCalculationUnitsNotifications: {
    columns: [
      { key: "detail", label: intl.formatMessage({ id: "notifications.fields.detail" }), size: 3 },
      { key: "period_name", label: intl.formatMessage({ id: "notifications.fields.period_name" }), size: 2 },
      { key: "created_at", label: intl.formatMessage({ id: "notifications.fields.created_at" }), 
        dataType: Constants.crudGenerator.dataTypes.DATETIME, align: Constants.style.alignTypes.CENTER, size: 2 },
      { key: "duration", label: intl.formatMessage({ id: "notifications.fields.duration" }), size: 2, align: Constants.style.alignTypes.CENTER },
      { key: "process_state", align: Constants.style.alignTypes.CENTER, 
       translateList:  "notifications.process_states", label: intl.formatMessage({ id: "notifications.fields.process_state" }), size: 2 },
      { key: "process_information", align: Constants.style.alignTypes.CENTER, 
       label: intl.formatMessage({ id: "notifications.fields.process_information" }), size: 2 }
    ],
    entityNamePlural: intl.formatMessage({ id: "calculationUnitAdmin.importCalculationUnitsInfo.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "calculationUnitAdmin.importCalculationUnitsInfo.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "calculationUnitAdmin.importCalculationUnitsInfo.genderVocal" })
  },
  reportTemplateList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "reportTemplateAdmin.fields.name" }), 
        sortable: true, size: 1 },
      { key: "default", label: intl.formatMessage({ id: "reportTemplateAdmin.fields.default" }), 
        sortable: true, dataType: Constants.crudGenerator.dataTypes.BOOLEAN, 
        align: Constants.style.alignTypes.CENTER, size: 1 },
      { key: "updated_at", label: intl.formatMessage({ id: "reportTemplateAdmin.fields.updated_at" }), 
        sortable: true, dataType: Constants.crudGenerator.dataTypes.DATETIME, 
        align: Constants.style.alignTypes.CENTER, size: 1 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "reportTemplateAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "reportTemplateAdmin.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "reportTemplateAdmin.genderVocal" })
  },
  emailDetailList: {
    columns: [
      { key: "created_at", label: intl.formatMessage({id: "reportFileAdmin.email.emailDetailList.created_at"}), 
        sortable: false, dataType: Constants.crudGenerator.dataTypes.DATETIME, size: 1 },      
      { key: "detail", label: intl.formatMessage({id: "reportFileAdmin.email.emailDetailList.detail"}), 
      sortable: false, size: 1 },
      { key: "calculation_units_info", label: intl.formatMessage({id: "reportFileAdmin.email.emailDetailList.calculation_units_count"}), 
        sortable: false, size: 1, align: Constants.style.alignTypes.CENTER },
    ],
    entityNamePlural: intl.formatMessage({ id: "reportFileAdmin.email.emailDetailList.entityNamePlural"}),      
    entityNameSingular: intl.formatMessage({ id: "reportFileAdmin.email.emailDetailList.entityNameSingular"}),
    genderVocal: intl.formatMessage({ id: "reportFileAdmin.email.emailDetailList.genderVocal"})
  },
  assignReportTemplateGroupGroupList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "groupAdmin.fields.name" }), size: 4 },
      { key: "report_templates_string", label: intl.formatMessage({ id: "assignReportTemplateGroupAdmin.reportTemplatesTitle" }), 
       align: Constants.style.alignTypes.LEFT, size: 3 }
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "groupAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "groupAdmin.entityNameSingular" })
  },
  assignReportTemplateGroupReportTemplateList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "reportTemplateAdmin.fields.name" }), size: 4 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "reportTemplateAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "reportTemplateAdmin.entityNameSingular" })
  },
  assignReportTemplateCalculationUnitCalculationUnitList: {
    columns: [
      { key: "name_code", sortField: "last_names", label: intl.formatMessage({ id: "calculationUnitAdmin.fields.name" }), size: 4 },
      { key: "report_templates_string", label: intl.formatMessage({ id: "assignReportTemplateCalculationUnitAdmin.reportTemplatesTitle" }), 
       align: Constants.style.alignTypes.LEFT, size: 3 }
    ],
    generalTextSearchFields: ["code", "last_names", "first_names"],
    entityNamePlural: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "calculationUnitAdmin.entityNamePlural"})),      
    entityNameSingular: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "calculationUnitAdmin.entityNameSingular"})),
  },
  assignReportTemplateCalculationUnitReportTemplateList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "reportTemplateAdmin.fields.name" }), size: 4 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "reportTemplateAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "reportTemplateAdmin.entityNameSingular" })
  },
  reportFilesList: {
    columns: [
      { key: "created_at", label: intl.formatMessage({ id: "reportFileAdmin.fields.created_at" }), 
        dataType: Constants.crudGenerator.dataTypes.DATETIME, size: 2 },
      { key: "detail", label: intl.formatMessage({ id: "reportFileAdmin.fields.detail" }), size: 3 },
      { key: "calculation_units_info", label: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "reportFileAdmin.fields.calculation_units_count" })), 
       size: 2, align: Constants.style.alignTypes.CENTER }
    ],
    entityNamePlural: intl.formatMessage({ id: "reportFileAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "reportFileAdmin.entityNameSingular" }),  
    entityNameSingularWithArticle: intl.formatMessage({ id: "reportFileAdmin.entityNameSingularWithArticle" }),
    genderVocal: intl.formatMessage({ id: "reportFileAdmin.genderVocal" })
  },
  reportFilesReprocessList: {
    columns: [
      { key: "created_at", label: intl.formatMessage({ id: "reportFileAdmin.fields.created_at" }), 
        dataType: Constants.crudGenerator.dataTypes.DATETIME, size: 2 },
      { key: "detail", label: intl.formatMessage({ id: "reportFileAdmin.fields.detail" }), size: 3 },
      { key: "calculation_units_info", label: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "reportFileAdmin.fields.calculation_units_count" })), 
       size: 2, align: Constants.style.alignTypes.CENTER },
      { key: "reprocess_label", label: intl.formatMessage({ id: "reportFileAdmin.fields.reprocess_label" }), size: 2, align: Constants.style.alignTypes.CENTER }
    ],
    entityNamePlural: intl.formatMessage({ id: "reportFileAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "reportFileAdmin.entityNameSingular" }),  
    entityNameSingularWithArticle: intl.formatMessage({ id: "reportFileAdmin.entityNameSingularWithArticle" }),
    genderVocal: intl.formatMessage({ id: "reportFileAdmin.genderVocal" })
  },
  biTemplateList: {
    columns: [
      { key: "polynomial_name", label: intl.formatMessage({ id: "biTemplateAdmin.fields.polynomial_name" }), 
        sortable: true, size: 1 },
      { key: "name", label: intl.formatMessage({ id: "biTemplateAdmin.fields.name" }), 
        sortable: true, size: 1 },
      { key: "is_outdated", label: intl.formatMessage({ id: "biTemplateAdmin.fields.is_outdated" }), 
        dataType: Constants.crudGenerator.dataTypes.BOOLEAN, 
        align: Constants.style.alignTypes.CENTER, size: 1 },
      { key: "updated_at", label: intl.formatMessage({ id: "biTemplateAdmin.fields.updated_at" }), 
        sortable: true, dataType: Constants.crudGenerator.dataTypes.DATETIME, 
        align: Constants.style.alignTypes.CENTER, size: 1 },
    ],
    generalTextSearchFields: ["polynomials.name", "bi_templates.name"],
    entityNamePlural: intl.formatMessage({ id: "biTemplateAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "biTemplateAdmin.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "biTemplateAdmin.genderVocal" })
  },
  calendarList: {
    columns: [
      { key: "extended_name", label: intl.formatMessage({id: "calendarAdmin.tableColumnLabel"}), 
        sortable: false, size: 1 },
    ],
    entityNamePlural: intl.formatMessage({ id: "calendarAdmin.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "calendarAdmin.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "calendarAdmin.genderVocal" })
  },
  rulesList: {
    columns: [
      { key: "extended_name", label: intl.formatMessage({id: "calendarAdmin.ruleTableColumnLabel"}), 
        sortable: false, size: 1 }
    ],
    entityNamePlural: intl.formatMessage({ id: "calendarAdmin.ruleEntityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "calendarAdmin.ruleEntityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "calendarAdmin.ruleGenderVocal" })
  },
  endpointsConnectorsList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "endpointsConnectorsAdmin.fields.name" }),
        sortable: true, size: 1 },
      { key: "endpoint_connector_type", label: intl.formatMessage({ id: "endpointsConnectorsAdmin.fields.endpoint_connector_type" }),
        translateList:  "endpointsConnectorsAdmin.fields.selectValues.endpoint_connector_type", sortable: true, size: 1 },
      { key: "updated_at", label: intl.formatMessage({ id: "endpointsConnectorsAdmin.fields.updated_at" }),
        sortable: true, dataType: Constants.crudGenerator.dataTypes.DATETIME,
        align: Constants.style.alignTypes.CENTER, size: 1 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "endpointsConnectorsAdmin.entityNamePlural" }),
    entityNameSingular: intl.formatMessage({ id: "endpointsConnectorsAdmin.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "endpointsConnectorsAdmin.genderVocal" })
  },
  endpointsConnectorsPanelList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "endpointsConnectorsPanel.fields.name" }),
        sortable: false, size: 1 },
      { key: "endpoint_connector_type", label: intl.formatMessage({ id: "endpointsConnectorsPanel.fields.endpoint_connector_type" }),
        translateList:  "endpointsConnectorsAdmin.fields.selectValues.endpoint_connector_type", sortable: false, size: 1 },
      { key: "connector_next_run", label: intl.formatMessage({ id: "endpointsConnectorsPanel.fields.connector_next_run" }),
        sortable: true, dataType: Constants.crudGenerator.dataTypes.DATETIME,
        align: Constants.style.alignTypes.CENTER, size: 1 },
      { key: "created_at", label: intl.formatMessage({ id: "endpointsConnectorsPanel.fields.created_at" }),
        sortable: true, dataType: Constants.crudGenerator.dataTypes.DATETIME,
        align: Constants.style.alignTypes.CENTER, size: 1 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "endpointsConnectorsPanel.entityNamePlural" }),
    entityNameSingular: intl.formatMessage({ id: "endpointsConnectorsPanel.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "endpointsConnectorsPanel.genderVocal" })
  },
  endpointsConnectorsVariablesList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "endpointsConnectorsVariablesAdmin.fields.name" }),
        sortable: true, size: 1 },
      { key: "to_show_value", label: intl.formatMessage({ id: "endpointsConnectorsVariablesAdmin.fields.value" }),
        sortable: true, size: 1 },
      { key: "updated_at", label: intl.formatMessage({ id: "endpointsConnectorsAdmin.fields.updated_at" }),
        sortable: true, dataType: Constants.crudGenerator.dataTypes.DATETIME,
        align: Constants.style.alignTypes.CENTER, size: 1 },
    ],
    generalTextSearchFields: ["name"],
    entityNamePlural: intl.formatMessage({ id: "endpointsConnectorsVariablesAdmin.entityNamePlural" }),
    entityNameSingular: intl.formatMessage({ id: "endpointsConnectorsVariablesAdmin.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "endpointsConnectorsVariablesAdmin.genderVocal" })
  },
  runConnectorsNotifications: {
    columns: [
      { key: "code", label: intl.formatMessage({ id: "notifications.fields.code" }), 
      translateList:  "notifications.codes", size: 2 },
      { key: "detail", label: intl.formatMessage({ id: "notifications.fields.detail" }), size: 3 },
      { key: "period_name", label: intl.formatMessage({ id: "notifications.fields.period_name" }), size: 2 },
      { key: "created_at", label: intl.formatMessage({ id: "notifications.fields.created_at" }), 
        dataType: Constants.crudGenerator.dataTypes.DATETIME, align: Constants.style.alignTypes.CENTER, size: 2 },
      { key: "duration", label: intl.formatMessage({ id: "notifications.fields.duration" }), size: 2, align: Constants.style.alignTypes.CENTER },
      { key: "process_state", align: Constants.style.alignTypes.CENTER, 
       translateList:  "notifications.process_states", label: intl.formatMessage({ id: "notifications.fields.process_state" }), size: 2 },
      { key: "process_information", align: Constants.style.alignTypes.CENTER, 
       label: intl.formatMessage({ id: "notifications.fields.process_information" }), size: 2 },
    ],
    entityNamePlural: intl.formatMessage({ id: "endpointsConnectorsVariablesAdmin.runConnectorsNotificationsInfo.entityNamePlural" }),      
    entityNameSingular: intl.formatMessage({ id: "endpointsConnectorsVariablesAdmin.runConnectorsNotificationsInfo.entityNameSingular" }),
    genderVocal: intl.formatMessage({ id: "endpointsConnectorsVariablesAdmin.runConnectorsNotificationsInfo.genderVocal" })
  },
  supervisorsRevisionsListByModel: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.modelRevisionsList.fields.name" }), size: 1},
      { key: "revision_stages", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.modelRevisionsList.fields.revision_stages" }),
        size: 1, align: Constants.style.alignTypes.CENTER },
      { key: "current_revision_stage", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.modelRevisionsList.fields.current_revision_stage" }),
      size: 1, align: Constants.style.alignTypes.CENTER },
      { key: "completion_percentage", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.modelRevisionsList.fields.completion_percentage" }),
      size: 1, align: Constants.style.alignTypes.CENTER },
      { key: "approval_status", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.modelRevisionsList.fields.approval_status" }), size: 1,
      translateList:  "supervisorsAdminRevisionPanel.revision_model_states" }
    ],
    entityNamePlural: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.modelRevisionsList.entityNamePlural" }),
    entityNameSingular: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.modelRevisionsList.entityNameSingular" }),    
    genderVocal: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.modelRevisionsList.genderVocal" }),
  },
  allSupervisorsRevisionsList: {
    columns: [
      { key: "revision_stage", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.fields.revision_stage" }), size: 1},
      { key: "polynomial_name", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.fields.polynomial_name" }), size: 1 }, 
      { key: "supervisor_email", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.fields.email" }), size: 1},     
      { key: "revision_created_at", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.fields.created_at" }),
        size: 1, dataType: Constants.crudGenerator.dataTypes.DATETIME, align: Constants.style.alignTypes.CENTER },
      { key: "revision_state", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.fields.revision_state" }),
      size: 1, translateList:  "supervisorsAdminRevisionPanel.revision_states", align: Constants.style.alignTypes.CENTER }
    ],
    entityNamePlural: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.entityNamePlural" }),
    entityNameSingular: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.entityNameSingular" }),    
    genderVocal: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.genderVocal" }),
  },
  revisionsGenerationsHistoryList: {
    columns: [      
      { key: "created_at", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsGenerationsHistoryList.fields.created_at" }), 
        size: 1, dataType: Constants.crudGenerator.dataTypes.DATETIME, align: Constants.style.alignTypes.CENTER },
      { key: "detail", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsGenerationsHistoryList.fields.detail" }), size: 1 },      
      { key: "admin_message", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsGenerationsHistoryList.fields.notes" }), size: 1 },      
      { key: "process_state", align: Constants.style.alignTypes.CENTER, 
        translateList:  "notifications.process_states", label: intl.formatMessage({ id: "notifications.fields.process_state" }), size: 1 },
      { key: "process_information", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsGenerationsHistoryList.fields.supervisors" }),
        size: 1, align: Constants.style.alignTypes.CENTER },
    ],
    entityNamePlural: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsGenerationsHistoryList.entityNamePlural" }),
    entityNameSingular: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsGenerationsHistoryList.entityNameSingular" }),    
    genderVocal: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsGenerationsHistoryList.genderVocal" }),
  },
  supervisorRevisionList: {
    columns: [
      { key: "models", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.fields.models" }), size: 1 }, 
      { key: "created_at", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.fields.created_at" }),
        size: 1, dataType: Constants.crudGenerator.dataTypes.DATETIME, align: Constants.style.alignTypes.CENTER },
      { key: "revision_state", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.fields.revision_state" }),
        size: 1, translateList:  "supervisorsAdminRevisionPanel.revision_states", align: Constants.style.alignTypes.CENTER },        
      { key: "admin_message", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.fields.notes" }), size: 1 },    
      { key: "supervisor_message", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.fields.supervisor_notes" }), size: 1 },
      { key: "active", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.fields.active" }), 
        dataType: Constants.crudGenerator.dataTypes.BOOLEAN, 
        align: Constants.style.alignTypes.CENTER, size: 1 }
    ],    
    entityNamePlural: intl.formatMessage({ id: "supervisorRevisionPanel.revisionsList.entityNamePlural" }),
    entityNameSingular: intl.formatMessage({ id: "supervisorRevisionPanel.revisionsList.entityNameSingular" }),    
    genderVocal: intl.formatMessage({ id: "supervisorRevisionPanel.revisionsList.genderVocal" }),
  },
  myRevisionsList: {
    columns: [
      { key: "polynomial_name", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.fields.polynomial_name" }), size: 1 }, 
      { key: "revision_stage", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.fields.revision_stage" }), size: 1},  
      { key: "revision_created_at", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.fields.created_at" }),
        size: 1, dataType: Constants.crudGenerator.dataTypes.DATETIME, align: Constants.style.alignTypes.CENTER },
      { key: "revision_state", label: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.fields.revision_state" }),
      size: 1, translateList:  "supervisorsAdminRevisionPanel.revision_states", align: Constants.style.alignTypes.CENTER }
    ],
    entityNamePlural: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.entityNamePlural" }),
    entityNameSingular: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.entityNameSingular" }),    
    genderVocal: intl.formatMessage({ id: "supervisorsAdminRevisionPanel.revisionsList.genderVocal" }),
  },
  exportConfigurationsList: {
    columns: [
      { key: "name", label: intl.formatMessage({ id: "exportConfigurationsAdmin.fields.name" }),
        sortable: true, size: 1 },
      { key: "description", label: intl.formatMessage({ id: "exportConfigurationsAdmin.fields.description" }),
      sortable: false, size: 3 },
    ],
    entityNamePlural: intl.formatMessage({ id: "exportConfigurationsAdmin.entityNamePlural" }),
    entityNameSingular: intl.formatMessage({ id: "exportConfigurationsAdmin.entityNameSingular" }),    
    genderVocal: intl.formatMessage({ id: "supervisorRevisionPanel.revisionsList.genderVocal" }),
  }
};

export default TableDescriptors;



// WEBPACK FOOTER //
// ./source/definitions/tableDescriptors.js